import { createAction, createActionGroup, props } from '@ngrx/store';
import { IUpdateLocalStatePayload } from '../interfaces/updateLocalState.interface';
import { AuthState } from './reducer.auth';

export const updateLocalAuthState = createAction(
  '[AUTH] update local auth state',
  props<IUpdateLocalStatePayload<AuthState>>(),
);

export const basicLoginActions = createActionGroup({
  source: 'AUTH',
  events: {
    'try login': props<{ body: any }>(),
    'login success': props<{ loginResponse: any }>(),
    'login failure': props<{ error: Error }>(),
  },
});

export const setSessionIdAction = createAction(
  '[AUTH] set session id',
  props<{ sessionId: string }>(),
);
